import { api } from "./client";
import type { BillingStatus } from "@/types/billing";

export const getBillingStatus = () =>
  api.get<BillingStatus>("/v1/billing/status", { serviceId: null });
